(()=>{const key='refashion-shopify-saved';let saved=[];try{const data=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(data))saved=data.filter(x=>x&&typeof x.handle==='string'&&typeof x.title==='string'&&typeof x.url==='string'&&x.url.startsWith('/')&&!x.url.startsWith('//'));}catch{}const sync=()=>{document.querySelectorAll('[data-save-handle]').forEach(b=>b.setAttribute('aria-pressed',String(saved.some(x=>x.handle===b.dataset.saveHandle))));const list=document.querySelector('[data-saved-list]');if(list){list.replaceChildren();if(!saved.length){const p=document.createElement('p');p.textContent=list.dataset.empty;list.append(p);}for(const item of saved){const row=document.createElement('p');const a=document.createElement('a');a.href=item.url;a.textContent=item.title;const b=document.createElement('button');b.textContent=list.dataset.remove;b.addEventListener('click',()=>{saved=saved.filter(x=>x.handle!==item.handle);persist();sync();});row.append(a,document.createTextNode(' '),b);list.append(row);}}};const persist=()=>{try{localStorage.setItem(key,JSON.stringify(saved));}catch{}};document.querySelectorAll('[data-save-handle]').forEach(b=>b.addEventListener('click',()=>{const item={handle:b.dataset.saveHandle,title:b.dataset.saveTitle,url:b.dataset.saveUrl};saved=saved.some(x=>x.handle===item.handle)?saved.filter(x=>x.handle!==item.handle):[...saved,item];persist();sync();}));document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.native-menu[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});sync();})();
(()=>{const dialog=document.createElement('dialog');dialog.className='refashion-quick-dialog';document.body.append(dialog);document.addEventListener('click',event=>{const trigger=event.target.closest('[data-product-quick]');if(trigger&&!event.metaKey&&!event.ctrlKey){const template=trigger.closest('.product-card').querySelector('[data-quick-template]');if(!template||typeof dialog.showModal!=='function')return;event.preventDefault();dialog.replaceChildren(template.content.cloneNode(true));dialog.setAttribute('aria-label',trigger.getAttribute('aria-label'));dialog.showModal();document.body.classList.add('no-scroll');}if(event.target.closest('[data-close-quick]'))dialog.close();});dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',()=>document.body.classList.remove('no-scroll'));if('IntersectionObserver' in window&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('revealed');observer.unobserve(entry.target);}}),{threshold:.06});document.querySelectorAll('.section-head,.product-card,.trust>div,.consign>div,.journal article,.newsletter>div').forEach(element=>{element.classList.add('reveal');observer.observe(element);});}})();

(() => {
  const current = document.querySelector('[data-current-piece]');
  const section = document.querySelector('[data-recent-pieces]');
  if (!current || !section) return;
  const key = 'refashion-recent-tab-v1';
  const validPath = value => typeof value === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+(?:\?[^#]*)?$/i.test(value);
  const safeImage = value => {
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
    } catch { return ''; }
  };
  let pieces = [];
  try {
    const parsed = JSON.parse(sessionStorage.getItem(key) || '[]');
    if (Array.isArray(parsed)) pieces = parsed.filter(item => item && typeof item.handle === 'string' && typeof item.title === 'string' && validPath(item.url)).slice(0, 8);
  } catch {}
  const list = section.querySelector('[data-recent-list]');
  const previous = pieces.filter(item => item.handle !== current.dataset.handle).slice(0, 4);
  for (const item of previous) {
    const link = document.createElement('a');
    link.href = item.url;
    const source = item.image ? safeImage(item.image) : '';
    if (source) {
      const img = document.createElement('img');
      img.src = source;
      img.alt = '';
      img.width = 500;
      img.height = 500;
      img.loading = 'lazy';
      link.append(img);
    }
    const title = document.createElement('span');
    title.textContent = item.title;
    link.append(title);
    list.append(link);
  }
  section.hidden = previous.length === 0;
  const item = {handle: current.dataset.handle, title: current.dataset.title, url: current.dataset.url, image: current.dataset.image || ''};
  if (validPath(item.url)) {
    try { sessionStorage.setItem(key, JSON.stringify([item, ...pieces.filter(piece => piece.handle !== item.handle)].slice(0, 8))); } catch {}
  }
  section.querySelector('[data-clear-recent]').addEventListener('click', () => {
    try { sessionStorage.removeItem(key); } catch {}
    list.replaceChildren();
    section.hidden = true;
  });
})();

(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;
  const cartPath = new URL(drawer.dataset.cartUrl, location.origin).pathname;
  let busy = false;
  let opener = null;
  const refresh = async () => {
    const url = new URL(drawer.dataset.cartUrl, location.origin);
    url.searchParams.set('section_id', 'cart-drawer');
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('cart-read');
    const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = documentCopy.querySelector('[data-cart-drawer]');
    if (!fresh) throw new Error('cart-markup');
    drawer.replaceChildren(...Array.from(fresh.childNodes));
    drawer.dataset.count = fresh.dataset.count;
    document.querySelectorAll('a[href]').forEach(link => {
      const destination = new URL(link.href, location.origin);
      if (destination.origin === location.origin && destination.pathname === cartPath && !destination.search) {
        link.textContent = link.textContent.replace(/\(\d+\)/, '(' + fresh.dataset.count + ')');
      }
    });
  };
  const open = () => {
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== drawer) other.close(); });
    if (!drawer.open) drawer.showModal();
  };
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-close-cart]')) { drawer.close(); return; }
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || url.pathname !== cartPath || url.search || link.target === '_blank') return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    opener = link;
    try { await refresh(); open(); } catch { location.assign(drawer.dataset.cartUrl); }
    finally { busy = false; }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    const action = new URL(form.action, location.origin);
    const addPath = new URL(drawer.dataset.addUrl, location.origin).pathname.replace(/\.js$/, '');
    if (action.origin !== location.origin || action.pathname !== addPath) return;
    if (event.submitter && event.submitter.name === 'checkout') return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    opener = event.submitter;
    const button = event.submitter;
    if (button) button.disabled = true;
    let errorBox = form.querySelector('[data-cart-error]');
    if (errorBox) errorBox.remove();
    try {
      const response = await fetch(drawer.dataset.addUrl, {method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: {Accept: 'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : drawer.dataset.error);
      try { await refresh(); open(); } catch { location.assign(drawer.dataset.cartUrl); }
    } catch (error) {
      errorBox = document.createElement('p');
      errorBox.dataset.cartError = '';
      errorBox.setAttribute('role', 'alert');
      errorBox.textContent = error.message === 'Failed to fetch' || error instanceof SyntaxError ? drawer.dataset.error : error.message;
      form.append(errorBox);
    } finally {
      busy = false;
      if (button) button.disabled = false;
    }
  });
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const bounds = drawer.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
  });
  drawer.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
})();

(() => {
  document.querySelectorAll('[data-variant-picker]').forEach(picker => {
    picker.addEventListener('change', () => {
      const option = picker.selectedOptions[0];
      if (!option || option.disabled) return;
      const product = picker.closest('.native-product');
      const price = product?.querySelector('[data-selected-price]');
      if (price) price.textContent = option.dataset.price;
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(history.state, '', url);
    });
  });
})();
